// services/AcademicYearService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

// LIST (paginated)
export function getAcademicYears(params = {}) {
    return api.get(ENDPOINTS.ACADEMIC_YEARS.BASE, { params });
}

// GET CURRENT
export function getCurrentAcademicYear() {
    return api.get(ENDPOINTS.ACADEMIC_YEARS.CURRENT);
}

// GET ONE
export function getAcademicYearById(id) {
    return api.get(ENDPOINTS.ACADEMIC_YEARS.BY_ID(id));
}

// CREATE
export function createAcademicYear(payload) {
    return api.post(ENDPOINTS.ACADEMIC_YEARS.BASE, payload);
}

// UPDATE
export function updateAcademicYear(id, payload) {
    return api.patch(ENDPOINTS.ACADEMIC_YEARS.BY_ID(id), payload);
}

// SET CURRENT
export function setCurrentAcademicYear(id) {
    return api.post(ENDPOINTS.ACADEMIC_YEARS.SET_CURRENT(id));
}

// DELETE (soft delete)
export function deleteAcademicYear(id) {
    return api.delete(ENDPOINTS.ACADEMIC_YEARS.BY_ID(id));
}

// RESTORE
export function restoreAcademicYear(id) {
    return api.post(`${ENDPOINTS.ACADEMIC_YEARS.BY_ID(id)}/restore`);
}
